import React, { useState, useEffect } from 'react'
import { FiClock, FiShield } from 'react-icons/fi'
import { useNavigate, Link } from 'react-router-dom'
import Loader from '../Loader'
import Userdashboardheader from '../userdashboardheader/Userdashboardheader'
import DashboardTopbar from '../dashboardShell/DashboardTopbar'
import PageHero from '../dashboardShell/PageHero'

const formatDate = (value) => new Date(value).toLocaleString(undefined, {
  year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
})

const UserdashboardLoginHistory = ({ route }) => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [history, setHistory] = useState([])

  useEffect(() => {
    const getHistory = async () => {
      try {
        setLoader(true)
        const token = localStorage.getItem('token')
        if (!token) { navigate('/login'); return }
        const data = await (await fetch(`${route}/api/loginHistory`, {
          headers: { 'x-access-token': token, 'Content-Type': 'application/json' }
        })).json()
        if (data.status === 401) { localStorage.removeItem('token'); navigate('/login') }
        else if (data.status === 200) setHistory(data.loginHistory)
      } catch { navigate('/login') }
      finally { setLoader(false) }
    }
    getHistory()
  }, [navigate, route])

  return (
    <div className="ud-layout">
      {loader && <Loader />}
      <Userdashboardheader route={route} />

      <div className="ud-main">
        <DashboardTopbar route={route} title="Login History" />

        <div className="ud-content">
          <PageHero
            icon={<FiClock />}
            eyebrow="Security"
            title="Login history"
            description="Your last 20 sign-ins. If you don't recognise one, change your password and turn on two-factor authentication."
          >
            <Link to="/2fa" className="ud-btn-ghost"><FiShield /> Manage 2FA</Link>
          </PageHero>

          <div className="ud-section-header">
            <h2>Recent sign-ins</h2>
            <p>Most recent first.</p>
          </div>

          {history.length === 0 && !loader ? (
            <div className="ud-card ud-empty">
              <p>No sign-ins recorded yet. New sign-ins will appear here.</p>
            </div>
          ) : (
            <div className="ud-table-wrap">
              <table className="ud-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Device</th>
                    <th>Location</th>
                    <th>IP address</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((entry, index) => (
                    <tr key={`${entry.date}-${index}`}>
                      <td>{formatDate(entry.date)}</td>
                      <td>{entry.browser} on {entry.os}</td>
                      <td>{entry.location || '—'}</td>
                      <td>{entry.ip || '—'}</td>
                      <td>
                        <span className="ud-badge ud-badge-profit">{index === 0 ? 'Latest' : 'Success'}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserdashboardLoginHistory
